import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { fetchCurrentUserLogo } from './actionCreators';

interface InitialState {
  isLoading: boolean,
  logo: string | null,
  error: string,
}

const initialState: InitialState = {
  isLoading: false,
  logo: null,
  error: '',
};

export const currentUserLogoSlice = createSlice({
  name: 'currentUserLogo',
  initialState,
  reducers: {
    removeCurrentUserLogo: (state) => {
      state.logo = null;
    },
  },
  extraReducers: {
    [fetchCurrentUserLogo.fulfilled.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = '';
      state.logo = action.payload;
    },
    [fetchCurrentUserLogo.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchCurrentUserLogo.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { removeCurrentUserLogo } = currentUserLogoSlice.actions;
export default currentUserLogoSlice.reducer;
